module.exports = __webpack_public_path__ + "img/code.9249b951.png";